import React, { useEffect, useState, useRef } from "react";
import "../../../../css/forms.css";
import logo from "../../../../assets/images/pass-logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { setUserSession } from "../../../../service/AuthService";


const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const email = useRef();
  const password = useRef();
  const [message, setMessage] = useState(null);
  const validateEmail = document.querySelector(".validate-email");
  const validatePassword = document.querySelector(".validate-password");
  const signInContainer = document.querySelector(".signin-container");
  const mybutton = document.querySelector(".secondary-btn");
  let timer1;
  let navigate = useNavigate();

  const requestUrl =
    "/signin";

  const validateInputs = () => {
    if (
      email.current.value.trim() === "" ||
      password.current.value.trim() === ""
    ) {
      setMessage("email and Password are required");
      validateEmail.classList.add("alert-validate");
      validatePassword.classList.add("alert-validate");
    }
  };

  
  const handleSignIn = (e) => {
    e.preventDefault();
    if (
      email.current.value.trim() === "" ||
      password.current.value.trim() === ""
    ) {
      setMessage("email and Password are required");
      validateEmail.classList.add("alert-validate");
      validatePassword.classList.add("alert-validate");
      mybutton.classList.add("headshake-anim");
      return;
    } else {
      setMessage("");
      validateEmail.classList.remove("alert-validate");
      validatePassword.classList.remove("alert-validate");
      mybutton.classList.remove("headshake-anim");
    }

    setMessage(null);

    const requestBody = {
      email: email.current.value,
      password: password.current.value,
    };
    setIsloading(!isloading);
    axios
      .post(requestUrl, requestBody)
      .then((response) => {
        signInContainer.classList.add("animate-pageright");
        setIsloading(isloading);
        setUserSession(response.data.user, response.data.token);
          timer1 = setTimeout(() => {
            navigate("/pass-account");
            console.log("Am working");
          }, 2000);
      
      })
      .catch((error) => {
        if (error.response.status === 403) {
          setIsloading(isloading);
          setMessage(error.response.data.message);
          validateEmail.classList.add("alert-validate");
          mybutton.classList.add("headshake-anim");
          console.log(error.response.data.message);
          signInContainer.classList.remove("animate-pageright");
          
        } else if (error.response.status === 404) {
          setIsloading(isloading);
          setMessage(error.response.data.message);
          mybutton.classList.add("headshake-anim");
          validatePassword.classList.add("alert-validate");
          console.log(error.response.data.message);
          signInContainer.classList.remove("animate-pageright");
          
        }
      });
  };

  const handleShowPass = () => {
    const password = document.getElementById("password");
    const icon = document.querySelector(".zmdi");

    setShowPassword(!showPassword);

    if (!showPassword) {
      password.setAttribute("type", "text");
      icon.classList.remove("zmdi-eye");
      icon.classList.add("zmdi-eye-off");
    } else {
      password.setAttribute("type", "password");
      icon.classList.remove("zmdi-eye-off");
      icon.classList.add("zmdi-eye");
    }
  };
  const focusFunction = () => {
    const inputEmail = document.querySelector(".input-email");
    const inputPassword = document.querySelector(".input-password");

    if (email.current.value.trim() !== "") {
      inputEmail.classList.add("has-val");
    } else {
      inputEmail.classList.remove("has-val");
    }

    if (password.current.value.trim() !== "") {
      inputPassword.classList.add("has-val");
    } else {
      inputPassword.classList.remove("has-val");
    }

    if (email.current.value.trim() !== "") {
      setMessage("");
      validateEmail.classList.remove("alert-validate");
    }
    if (password.current.value.trim() !== "") {
      setMessage("");
      validatePassword.classList.remove("alert-validate");
    }
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return(()=>{
      clearTimeout(timer1);
    })
  });
  return (
    <div className="">
      <div className="container" style={{marginTop: "-30px"}}>
        <div className="">
          <div className="signin-container">
            <div className="signin-inner">
              <div className="signin-form-header">
                <img src={logo} alt="" />
                <div className="signin-form-title">
                  <h3>Welcome Employee</h3>
                </div>
              </div>

              <form className="signin-form" onSubmit={handleSignIn}>
                <div
                  className="wrap-input-signin validate-email"
                  data-validate={message}
                >
                  <input
                    type="email"
                    ref={email}
                    className="input-email"
                    onChange={focusFunction}
                  />
                  <span
                    className="focus-input-email"
                    data-placeholder="Email"
                  ></span>
                </div>
                <div
                  className="wrap-input-signin validate-password"
                  data-validate={message}
                >
                  <span className="btn-show-pass" onClick={handleShowPass}>
                    <i className="zmdi zmdi-eye"></i>
                  </span>
                  <input
                    className="input-password"
                    type="password"
                    id="password"
                    ref={password}
                    onChange={focusFunction}
                  />
                  <span
                    className="focus-input-password"
                    data-placeholder="Password"
                  ></span>
                </div>

                {!isloading ? (
                  <button
                    type="submit"
                    className="secondary-btn"
                    onClick={validateInputs}
                  >
                    Sign In
                  </button>
                ) : (
                  <div className="pass-loader-container">
                    <div className="pass-loader-mini"></div>
                  </div>
                )}
              </form>
              <div className="forgot-password">
                <NavLink to="forgot-password?" className="forgot-password-link">
                  Forgot Password?
                </NavLink>
              </div>
              <div className="signup-link-lbl">
                <label>
                  Don't have an account?
                  <span>
                    <NavLink to="/signup"> Sign Up</NavLink>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
